import { render } from "./EditAsset.vue?vue&type=template&id=4edffb02&scoped=true"
import script from "./EditAsset.vue?vue&type=script&lang=js"
export * from "./EditAsset.vue?vue&type=script&lang=js"

import "./EditAsset.vue?vue&type=style&index=0&id=4edffb02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edffb02"]])

export default __exports__